var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill: #2b2828;}.cls-2{fill:#efeff5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.23 0 30 7.78 22.78 15 30 22.22 22.23 30 7.23 15 22.23 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.77 0 0 7.78 7.22 15 0 22.22 7.77 30 22.77 15 7.77 0"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiAjMmIyODI4O30uY2xzLTJ7ZmlsbDojZWZlZmY1O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iVnJzdHZhXzEiIGRhdGEtbmFtZT0iVnJzdHZhIDEiPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMi4yMyAwIDMwIDcuNzggMjIuNzggMTUgMzAgMjIuMjIgMjIuMjMgMzAgNy4yMyAxNSAyMi4yMyAwIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjcuNzcgMCAwIDcuNzggNy4yMiAxNSAwIDIyLjIyIDcuNzcgMzAgMjIuNzcgMTUgNy43NyAwIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgX404 as ReactComponent };